import {actionMap} from '../reducers/index'
import * as types from './types'
import resetError from 'shared/errorHandler/actions/resetError'

export default ({productId, format}) => dispatch => {
    dispatch({type: types.GET_PRODUCT_START, productId: productId})
    dispatch(resetError())
    window.open('/api/fb/briefing/product/' + productId + '?format=' + format, '_blank')
    dispatch({type: types.GET_PRODUCT_FINISH, productId: productId})
}

export const handler_GET_PRODUCT_START = (reduxState, action) => {
    let newLoadingIds = reduxState.loadingIds !== undefined ? reduxState.loadingIds : []
    newLoadingIds.push(action.productId)

    return ({
        ...reduxState,
        loadingIds: newLoadingIds.slice(0)
    })
}

export const handler_GET_PRODUCT_FINISH = (reduxState, action) => {
    let newLoadingIds = reduxState.loadingIds !== undefined ? reduxState.loadingIds : []
    newLoadingIds = newLoadingIds.filter(item => item !== action.productId)
    return ({
        ...reduxState,
        loadingIds: newLoadingIds
    })
}

actionMap[types.GET_PRODUCT_START] = handler_GET_PRODUCT_START
actionMap[types.GET_PRODUCT_FINISH] = handler_GET_PRODUCT_FINISH


// WEBPACK FOOTER //
// ./src/screens/briefing/products/actions/getProduct.js